<template>
  <v-dialog
    v-model="intDialogVisible"
    persistent
    width="auto "
    max-width="400"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>

      <v-card-text>
        <p v-for="(text, index) in content.split('\n')" :key="index">
          {{ text }}
        </p>
      </v-card-text>

      <v-card-actions data-cy="validationButtons">
        <v-container class="ma-0 pa-0 mw-100" v-if="buttons[0]">
          <custom-button
            :isText="isText"
            :text="buttons[0]"
            @click="$emit('close')"
          />
        </v-container>
        <v-spacer v-if="buttons[1]" />
        <v-container class="ma-0 pa-0 mw-100" v-if="buttons[1]">
          <custom-button :text="buttons[1]" @click="$emit('done')" />
        </v-container>
        <v-spacer v-if="buttons[2]" />
        <v-container class="ma-0 pa-0 mw-100" v-if="buttons[2]">
          <custom-button :text="buttons[2]" @click="$emit('done2')" />
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * @vue-prop {String} title - title of the dialog
 * @vue-prop {String} content - content of the dialog
 * @vue-prop {Array} buttons - buttons in the dialog
 * @vue-prop {Boolean} dialog - checks, if dialog is visible
 * @vue-prop {Number} width - width of dialog
 * @vue-data {Boolean}[isText=true] isText - checks, if input is text
 * @vue-computed {} get() - returns, if dialog is visible
 * @vue-computed {Boolean} set(value) - sends close to vuex store, if value = false
 */
import CustomButton from "../input/CustomButton";

export default {
  name: "validation-dialog",
  components: {
    CustomButton,
  },
  props: {
    title: String,
    content: String,
    buttons: Array,
    dialog: Boolean,
    width: Number,
  },
  data() {
    return {
      isText: true,
    };
  },
  computed: {
    intDialogVisible: {
      get: function() {
        return this.dialog;
      },
      set: function(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>
